import { defineComponent as B, mergeModels as x, useModel as I, computed as P, toValue as m, onMounted as w, onUnmounted as A, watch as J, nextTick as h, ref as S, provide as K, createElementBlock as u, openBlock as p, mergeProps as N, unref as l, createElementVNode as c, normalizeClass as i, createCommentVNode as T, createVNode as $, withCtx as L, renderSlot as b, Fragment as H, renderList as q, createBlock as O, createTextVNode as U, toDisplayString as z } from "vue";
import a from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/JumpLinks/jump-links.js";
import { classesFromBreakpointProps as D } from "../../breakpoints.js";
import { provideChildrenTracker as R } from "../../use/children-tracker.js";
import { computedWithControl as j } from "@vueuse/core";
import { AngleRightIcon as V } from "../../packages/icons/dist/esm/icons/angle-right-icon.js";
import W from "./JumpLinksItem.vue2.js";
import X from "../Button.vue2.js";
import { useOUIAProps as _ } from "../../helpers/ouia.js";
const G = Symbol("FormSelectOptionsKey"), Q = Symbol("JumpLinkInjectionKey"), se = /* @__PURE__ */ B({
  name: "PfJumpLinks",
  __name: "JumpLinks",
  props: /* @__PURE__ */ x({
    centered: { type: Boolean },
    vertical: { type: Boolean },
    alwaysShowLabel: { type: Boolean, default: !0 },
    scrollableElement: {},
    autoLinkFromElements: {},
    offset: { default: 100 },
    toggleAriaLabel: { default: "Toggle jump links" },
    ouiaId: {},
    ouiaSafe: { type: Boolean },
    expandable: {},
    expandableSm: {},
    expandableMd: {},
    expandableLg: {},
    expandableXl: {},
    expandable2xl: {}
  }, {
    expanded: { type: Boolean, default: !1 },
    expandedModifiers: {}
  }),
  emits: /* @__PURE__ */ x(["update:activeIndex"], ["update:expanded"]),
  setup(g) {
    const t = g, C = _({ id: t.ouiaId, safe: t.ouiaSafe }), d = I(g, "expanded"), F = P(() => D(t, ["expandable"], a, { short: !0 })), M = R(G), r = j(() => [t.scrollableElement, t.autoLinkFromElements], () => {
      if (t.scrollableElement) {
        if (typeof t.scrollableElement == "string") {
          const e = document.querySelector(t.scrollableElement);
          return e instanceof HTMLElement ? e : void 0;
        }
        return m(t.scrollableElement);
      }
    }), v = j(() => [r, t.autoLinkFromElements], () => {
      const e = m(r), o = [];
      return typeof t.autoLinkFromElements == "string" ? e && o.push(...[
        ...e.querySelectorAll(t.autoLinkFromElements)
      ].filter((n) => n instanceof HTMLElement)) : t.autoLinkFromElements && o.push(...m(t.autoLinkFromElements)), o;
    });
    w(r.trigger), A(() => {
      var e;
      return (e = m(r)) == null ? void 0 : e.removeEventListener("scroll", k);
    }), J(r, (e, o) => {
      o == null || o.removeEventListener("scroll", k), e == null || e.addEventListener("scroll", k), h(v.trigger);
    }, { immediate: !0 });
    const f = S(0), E = S();
    K(Q, {
      offset: t.offset,
      scrollPosition: f,
      currentTargetPosition: E,
      scrollableHTMLElement: r
    });
    function k() {
      const e = m(r);
      e && (f.value = Math.ceil(e.scrollTop + t.offset), h(() => {
        const o = M.map((n) => {
          var y;
          const s = (y = n.$.exposed) == null ? void 0 : y.target.value;
          return (s == null ? void 0 : s.offsetTop) ?? null;
        }).filter((n) => n !== null && n < f.value).sort((n, s) => (n ?? -1) - (s ?? -1));
        E.value = o.length > 0 ? o[o.length - 1] : void 0;
      }));
    }
    return (e, o) => (p(), u("nav", N(l(C), {
      class: [
        l(a).jumpLinks,
        F.value,
        {
          [l(a).modifiers.center]: e.centered,
          [l(a).modifiers.vertical]: e.vertical,
          [l(a).modifiers.expanded]: d.value
        }
      ]
    }), [
      c("div", {
        class: i(l(a).jumpLinksMain)
      }, [
        c("div", {
          class: i(`${l(a).jumpLinks}__header`)
        }, [
          e.expandable ? (p(), u("div", {
            key: 0,
            class: i(l(a).jumpLinksToggle)
          }, [
            $(X, {
              variant: "plain",
              "aria-label": e.toggleAriaLabel,
              "aria-expanded": d.value,
              onClick: o[0] || (o[0] = (n) => d.value = !d.value)
            }, {
              icon: L(() => [
                c("span", {
                  class: i(l(a).jumpLinksToggleIcon)
                }, [
                  $(l(V))
                ], 2)
              ]),
              default: L(() => [
                b(e.$slots, "label")
              ]),
              _: 3
            }, 8, ["aria-label", "aria-expanded"])
          ], 2)) : T("", !0),
          e.$slots.label && e.alwaysShowLabel ? (p(), u("div", {
            key: 1,
            class: i(l(a).jumpLinksLabel)
          }, [
            b(e.$slots, "label")
          ], 2)) : T("", !0)
        ], 2),
        c("ul", {
          class: i(l(a).jumpLinksList),
          role: "list"
        }, [
          b(e.$slots, "default"),
          (p(!0), u(H, null, q(l(v), (n, s) => (p(), O(W, {
            key: `${s}:${n.textContent}`,
            node: n
          }, {
            default: L(() => [
              U(z(n.textContent), 1)
            ]),
            _: 2
          }, 1032, ["node"]))), 128))
        ], 2)
      ], 2)
    ], 16));
  }
});
export {
  Q as JumpLinkInjectionKey,
  G as JumpLinksKey,
  se as default
};
